export const TalkbackMobileBanner = () => (
  <svg width="300" height="227" viewBox="0 0 300 227" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4309_42921)">
      <rect width="300" height="227" fill="url(#paint0_linear_4309_42921)" />
      <path
        d="M227.996 24.104C244.509 24.104 257.896 36.3234 257.896 51.396V402.604C257.895 417.677 244.509 429.895 227.996 429.895H70.6602C54.1477 429.895 40.7618 417.676 40.7617 402.604V51.396C40.7617 36.3235 54.1477 24.1042 70.6602 24.104H227.996Z"
        fill="#DADFE3"
      />
      <path
        d="M227.017 52C238.115 52.0002 247.112 59.7932 247.112 69.4062V403.095C247.112 412.708 238.115 420.5 227.017 420.5H71.6406C60.5422 420.5 51.5452 412.708 51.5449 403.095V69.4062C51.5449 59.7932 60.5421 52.0001 71.6406 52H227.017Z"
        fill="#F6F8F9"
      />
      <path
        d="M224.891 32.0762C237.041 32.0762 246.891 41.9259 246.891 54.0762V125.076H51.8906V54.0762C51.8906 41.9259 61.7404 32.0762 73.8906 32.0762H224.891Z"
        fill="white"
      />
      <g filter="url(#filter0_d_4309_42921)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M64 85C64 88.3137 66.6863 91 70 91H102C105.314 91 108 88.3137 108 85V53C108 49.6863 105.314 47 102 47H70C66.6863 47 64 49.6863 64 53V85Z"
          fill="#E6EAED"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114 64.3311C114 65.2528 114.747 66 115.669 66H193.331C194.253 66 195 65.2528 195 64.3311V53.6689C195 52.7472 194.253 52 193.331 52H115.669C114.747 52 114 52.7472 114 53.6689V64.3311Z"
        fill="#E6EAED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64 104C64 107.417 66.7702 110.188 70.1875 110.188H105.545C108.962 110.188 111.732 107.417 111.732 104C111.732 100.583 108.962 97.8125 105.545 97.8125H70.1875C66.7702 97.8125 64 100.583 64 104Z"
        fill="#E6EAED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.268 104C115.268 107.417 118.038 110.188 121.455 110.188H156.812C160.229 110.188 163 107.417 163 104C163 100.583 160.229 97.8125 156.812 97.8125H121.455C118.038 97.8125 115.268 100.583 115.268 104Z"
        fill="#E6EAED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114 73.3311C114 74.2528 114.747 75 115.669 75H180.331C181.253 75 182 74.2528 182 73.3311V70.6689C182 69.7472 181.253 69 180.331 69H115.669C114.747 69 114 69.7472 114 70.6689V73.3311Z"
        fill="#E6EAED"
      />
      <g filter="url(#filter1_d_4309_42921)">
        <circle cx="193.501" cy="104" r="12.9167" fill="#D2252A" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M193.498 97.0234C194.782 97.0234 195.823 98.0096 195.823 99.2261V104.366C195.823 105.582 194.782 106.568 193.498 106.568C192.214 106.568 191.173 105.582 191.173 104.366V99.2261C191.173 98.0096 192.214 97.0234 193.498 97.0234ZM197.566 101.796C197.245 101.796 196.985 102.042 196.985 102.346V104.366C196.985 106.19 195.424 107.669 193.498 107.669C191.572 107.669 190.01 106.19 190.01 104.366V102.346C190.01 102.042 189.75 101.796 189.429 101.796C189.108 101.796 188.848 102.042 188.848 102.346V104.366C188.849 106.585 190.592 108.457 192.916 108.734V109.872H191.366C191.045 109.872 190.785 110.119 190.785 110.423C190.785 110.727 191.045 110.973 191.366 110.973H195.629C195.95 110.973 196.21 110.727 196.21 110.423C196.21 110.119 195.95 109.872 195.629 109.872H194.079V108.734C196.403 108.457 198.147 106.585 198.148 104.366V102.346C198.148 102.042 197.887 101.796 197.566 101.796Z"
        fill="white"
      />
      <circle cx="227" cy="104" r="14" fill="#E6EAED" />
      <g filter="url(#filter2_d_4309_42921)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72 287C72 290.314 74.6863 293 78 293H219C222.314 293 225 290.314 225 287V146C225 142.686 222.314 140 219 140H78C74.6863 140 72 142.686 72 146V287Z"
          fill="#E6EAED"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_4309_42921"
        x="63.1656"
        y="46.4437"
        width="45.6689"
        height="45.6689"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.278146" />
        <feGaussianBlur stdDeviation="0.417219" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4309_42921" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4309_42921" result="shape" />
      </filter>
      <filter
        id="filter1_d_4309_42921"
        x="177.355"
        y="88.9307"
        width="32.2923"
        height="32.2918"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.07639" />
        <feGaussianBlur stdDeviation="1.61458" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4309_42921" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4309_42921" result="shape" />
      </filter>
      <filter
        id="filter2_d_4309_42921"
        x="71.1656"
        y="139.444"
        width="154.669"
        height="154.669"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.278146" />
        <feGaussianBlur stdDeviation="0.417219" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4309_42921" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4309_42921" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_4309_42921"
        x1="0"
        y1="0"
        x2="110.366"
        y2="297.379"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9B699" />
        <stop offset="1" stopColor="#E22C3A" />
      </linearGradient>
      <clipPath id="clip0_4309_42921">
        <rect width="300" height="227" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
